module.exports = __webpack_public_path__ + "img/g2-talent.766738af.png";